interface BuildInfo {
  appname: string;
  version: string;
  message: string;
  author: string;
  branch_name: string;
  environment_name: string;
  deployment_time: string;
  pipeline_url: string | null;
}

interface DisplayInfo {
  appname: string;
  version: string;
  fullVersion: string;
  message: string;
  author: string;
  branch: string;
  environment: string;
  deploymentTime: string;
  pipelineUrl: string | null;
}

export class BuildInfoService {
  private static buildInfo: BuildInfo | null = null;

  static getBuildInfo(): BuildInfo | null {
    if (this.buildInfo) return this.buildInfo;

    const buildInfoBase64 = import.meta.env.VITE_BUILD_INFO;
    if (!buildInfoBase64) {
      return null;
    }

    try {
      const buildInfoJson = atob(buildInfoBase64);
      this.buildInfo = JSON.parse(buildInfoJson);
      return this.buildInfo;
    } catch (error) {
      console.error('Failed to parse build info:', error);
      return null;
    }
  }

  static getDisplayInfo(): DisplayInfo | null {
    const info = this.getBuildInfo();
    if (!info) return null;

    return {
      appname: info.appname,
      version: info.version.substring(0, 8),
      fullVersion: info.version,
      message: info.message,
      author: info.author,
      branch: info.branch_name,
      environment: info.environment_name,
      deploymentTime: info.deployment_time,
      pipelineUrl: info.pipeline_url || null,
    };
  }
}
